// import useJwt from '@core/auth/jwt/useJwt'
import axios from '@axios'
import jwtConfig from './jwtConfig'
import JwtService from './jwtService'

const jwt = new JwtService(axios, jwtConfig)

export default jwt
